const storageKeyPrefix = 'VistaOmnichannelComponents';
const storageKeySeparator = '::';
export const getStorageKey = (key) => `${storageKeyPrefix}${storageKeySeparator}${key}`;
const keyPrefixRegExp = new RegExp(`^${storageKeyPrefix}(.*)`);
export const isStorageKey = (key) => key.match(keyPrefixRegExp) !== null;
export const versionNumberStorageKey = getStorageKey('version-number');
const reservedStorageKeys = [versionNumberStorageKey];
export const isReservedStorageKey = (key) => reservedStorageKeys.includes(key);
